(function(app) {

    app.constant("timelineEventTypes",
        [
            { ShortName: "NoteAdded", DisplayName: "Note Added" },
            { ShortName: "TaskAdded", DisplayName: "Added to a Scheduled Task" },
            { ShortName: "TaskCompleted", DisplayName: "Scheduled Task Completed" },
            { ShortName: "TaskReassigned", DisplayName: "Removed from a Scheduled Task" },
            { ShortName: "AppointmentAdded", DisplayName: "Added to an Appointment"},
            { ShortName: "AppointmentCompleted", DisplayName: "Appointment Completed" },
            { ShortName: "AppointmentAttendeeRemoved", DisplayName: "Removed from an Appointment" }
        ]);

})(window.app); //jshint ignore:line